import React, { useCallback } from "react";

import { useIntl } from "react-intl";

import FilterOperator from "@mapmycustomers/shared/enum/FilterOperator";
import {
  IFilterComponentProps,
  IFilterInstance,
} from "@mapmycustomers/shared/types/fieldModel/IFilterConfig";
import { NumberField, NumberFieldComponent } from "@mapmycustomers/ui";

import styles from "./FrequencyIntervalFilter.module.scss";

const handleUpdateFrequency = (valueStr?: string) => parseInt(valueStr ?? "", 10);

export const FREQUENCY_NUMBER_FILTER_OPERATORS = [
  FilterOperator.EQUALS,
  FilterOperator.GREATER_THAN,
  FilterOperator.GREATER_THAN_OR_EQUAL,
  FilterOperator.LESS_THAN,
  FilterOperator.LESS_THAN_OR_EQUAL,
  FilterOperator.EMPTY,
  FilterOperator.NOT_EMPTY,
];

interface FrequencyIntervalFilterProps extends IFilterComponentProps {}

const FrequencyIntervalFilter: IFilterInstance = {
  doesSupportValue: (value: any, operator: FilterOperator) => {
    return typeof value === "number" && FREQUENCY_NUMBER_FILTER_OPERATORS.includes(operator);
  },
  getComponent:
    (): React.FunctionComponent<FrequencyIntervalFilterProps> =>
    ({ className, disabled, focus, onChange, placeholder, value }) => {
      const intl = useIntl();

      const setRef = useCallback(
        (ref: null | NumberFieldComponent) => {
          if (focus && ref) {
            ref.focus();
          }
        },
        [focus]
      );

      if ([FilterOperator.EMPTY, FilterOperator.NOT_EMPTY].includes(value.operator)) {
        return null;
      }

      return (
        <div className={styles.container}>
          <NumberField
            disabled={disabled}
            inputClassName={className}
            min={1}
            onChange={(number) => onChange?.({ ...value, value: number })}
            parser={handleUpdateFrequency}
            placeholder={placeholder as string}
            ref={setRef}
            size="middle"
            value={value?.value}
          />
          <span className={styles.suffix}>
            {intl.formatMessage({
              id: "filters.frequencyInterval.text",
              defaultMessage: "days",
              description: "text in frequency Interval field filter",
            })}
          </span>
        </div>
      );
    },
};

export default FrequencyIntervalFilter;
